export default window.self !== window.top;